export function getDevicePixelRatio(): number {
  return window.devicePixelRatio ?? 1;
}
